/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Title_LeadInputs */

const en_for_whom_title_lead = /** @type {(inputs: For_Whom_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your goal.`)
};

const pl_for_whom_title_lead = /** @type {(inputs: For_Whom_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój cel.`)
};

/**
* | output |
* | --- |
* | "Your goal." |
*
* @param {For_Whom_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_title_lead = /** @type {((inputs?: For_Whom_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_title_lead(inputs)
	return en_for_whom_title_lead(inputs)
});